<div class="d-flex flex-column flex-sm-row input-btn-group mb-2">
  <div class="mb-2 me-sm-2">
    <button class="btn btn-primary btn-lg w-100" (click)="openAddTemplate()">
      + Add Company
    </button>
  </div>
</div>
<div class="row row-cols-2">
  <div class="col-12 col-md-6 col-lg-3">
    <gtapp-gt-custom-table
      [deskTopTableData]="contactorsListData"
      [desktopTableDetails]="contactorTableDetails"
      [tableStyle]="tableStyle"
      [otherParams]="otherParamsContractors"
      (rowClick)="onTableRowClick($event)"
      (sortColumn)="sortColumnContractor($event)"
      (searchColumn)="searchColumnContractor($event)"
      (paginationChange)="onChangePaginationContractor($event)"
    ></gtapp-gt-custom-table>
  </div>
  @if (selectedContractor?.id) {
    <div class="col-12 col-md-6 col-lg-9">
      <gtapp-add-edit-sub-contractor
        (eventUpdated)="updateListData($event)"
        [subContractorId]="selectedContractor?.id"
      ></gtapp-add-edit-sub-contractor>
    </div>
  }
</div>
